import { Application, BasePlugin } from '@goodboydigital/astro';
import { Container } from 'pixi.js';

import { App } from '../App';
import { ConfirmPopUp, ConfirmPopUpOptions } from '../ui/popups/ConfirmPopup';
import { ConfirmPurchasePopup, ConfirmPurchasePopupOptions } from '../ui/popups/ConfirmPurchasePopup';
import { DownloadPopup } from '../ui/popups/DownloadPopup';
import { PrizePopup, PrizePopupOptions } from '../ui/popups/PrizePopup';
import { RankStatsPopup } from '../ui/popups/RankStatsPopup';

export class PopupPlugin implements BasePlugin
{
    public app: App;
    public view: Container;
    private popupPrize?: PrizePopup;
    private popupConfirm?: ConfirmPopUp;
    private popupConfirmPurchase?: ConfirmPurchasePopup;
    private popupDownload?: DownloadPopup;
    private popupRankStats?: RankStatsPopup;

    constructor(app: Application)
    {
        this.app = app as App;
        this.view = new Container();
    }

    public async presentPrizePopup(opts?: Partial<PrizePopupOptions>): Promise<void>
    {
        this.app.stage.stage.addChild(this.view);

        if (!this.popupPrize) this.popupPrize = new PrizePopup(this.app);
        this.popupPrize.present(opts);
    }

    public async presentDownloadPopup(opts?: Partial<PrizePopupOptions>): Promise<void>
    {
        this.app.stage.stage.addChild(this.view);

        if (!this.popupDownload) this.popupDownload = new DownloadPopup(this.app);
        this.popupDownload.present(opts);
    }

    public async presentConfirmPopup(opts: Partial<ConfirmPopUpOptions> = {}): Promise<void>
    {
        this.app.stage.stage.addChild(this.view);

        if (!this.popupConfirm) this.popupConfirm = new ConfirmPopUp(this.app);
        this.popupConfirm.present(opts);
    }

    public async presentConfirmPurchasePopup(opts: Partial<ConfirmPurchasePopupOptions> = {}): Promise<void>
    {
        this.app.stage.stage.addChild(this.view);

        if (!this.popupConfirmPurchase) this.popupConfirmPurchase = new ConfirmPurchasePopup(this.app);
        this.popupConfirmPurchase.present(opts);
    }

    public async presentRankStatsPopup(): Promise<void>
    {
        this.app.stage.stage.addChild(this.view);

        if (!this.popupRankStats) this.popupRankStats = new RankStatsPopup(this.app);
        this.popupRankStats.present();
    }

    public async dismissPopup(): Promise<void>
    {
        if (this.popupPrize) this.popupPrize.dismiss();
        if (this.popupConfirm) this.popupConfirm.dismiss();
        if (this.popupDownload) this.popupDownload.dismiss();
        if (this.popupConfirmPurchase) this.popupConfirmPurchase.dismiss();
        if (this.popupRankStats) this.popupRankStats.dismiss();
    }
}
